import { render, staticRenderFns } from "./VirtualOperatorSettings.vue?vue&type=template&id=2b806c2a&scoped=true"
import script from "./VirtualOperatorSettings.vue?vue&type=script&lang=ts"
export * from "./VirtualOperatorSettings.vue?vue&type=script&lang=ts"
import style0 from "./VirtualOperatorSettings.vue?vue&type=style&index=0&id=2b806c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b806c2a",
  null
  
)

export default component.exports